import React from 'react';
import { useSelector } from 'react-redux';

const StepIndicator = ({ id, progress, stepNumber, stepIndex }) => {
  const { completedSteps } = useSelector(state => state);
  const completed =
    (!!progress && progress.completedDate) || stepIndex <= completedSteps;

  return (
    <div
      id={`step-${id}`}
      className={
        completed ? 'JourneyContentCollapsed-step' : 'JourneyContentStep'
      }
    >
      {!completed && (
        <span className="PathContentStep-position">{stepNumber}</span>
      )}
    </div>
  );
};

export default StepIndicator;
